// extracted by css-extract-rspack-plugin
export default {"cls1":"shared-cls1_h0V","cls2":"shared-cls2_cle shared-cls1_h0V"};